import { createGlobalStyle } from "styled-components";

export const AppGlobalStyles = createGlobalStyle`
body {
  background: ${({ theme }) => theme.colors.white};
}

.grecaptcha-badge {
  visibility: hidden;
}
`;
